import React from 'react';
import classNames from 'classnames';

import { Icon } from '@eb/eds-icon';
import { Trending as TrendingSvg } from '@eb/eds-iconography';

import './TrendingSearchesAnchor.scss';

export const TrendingSearchesAnchor = ({
    trendingSearchData,
    containerClassNames = [],
}) => {
    let component = null;

    if (trendingSearchData) {
        const trendingSearchesAnchorClasses = classNames(
            'trending-searches-anchor',
            'eds-align--center',
            ...containerClassNames,
        );

        component = (
            <div
                className={trendingSearchesAnchorClasses}
                data-testid="trending-searches-anchor"
            >
                <a
                    href={trendingSearchData.path}
                    className="eds-text-weight--heavy eds-align--center"
                >
                    <span className="eds-l-mar-right-3">
                        <Icon type={<TrendingSvg />} />
                    </span>
                    {trendingSearchData.text}
                </a>
            </div>
        );
    }

    return component;
};
